export const CardPointeGatewayEnvironment = {
    PRODUCTION: 'PRODUCTION',
    SANDBOX: 'SANDBOX',
} as const;

export type CardPointeGatewayEnvironment =
    (typeof CardPointeGatewayEnvironment)[keyof typeof CardPointeGatewayEnvironment];
